import React, { Fragment } from "react";
import {
  useQuery,
  useApolloClient,
} from "@apollo/react-hooks";
import gql from "graphql-tag";
import { Loading, PageHeading } from "../components";
import { makeStyles } from "@material-ui/core/styles";
import Box from "@material-ui/core/Box";
import Typography from "@material-ui/core/Typography";
import { loadStripe } from "@stripe/stripe-js/pure";
import { Grid, ButtonBase } from "@material-ui/core";
import { navigate } from "@reach/router";
import Login from "./login";

// loadStripe.setLoadParameters({advancedFraudSignals: false})

const useStyles = makeStyles((theme) => ({
  reserveHeading: { marginBottom: 6 },
  // menuItem: { width: "100%" },
  buttonBase: { display: "block" }
}))

export const GET_CARTLEASE_CARTCAR = gql`
  query getCartLeaseCartCar {
    cartCar @client {
      vin
      year
      make
      model
      images
    }
    cartLease @client {
      __typename
      pickupLocation
      dropoffLocation
      transportCost
      secondLegFee
      dropoffLegFee
      leaseTotal
      firstMonthSalesTax
      firstMonthRentalTax
      monthlySalesTax
      monthlyRentalTax
      proration
      dropoffLegSalesTax
      dropoffLegRentalTax
      paymentsTotal
      leaseFirst
      leaseMonthly
      customerPickupDate
      customerLeaseMonths
      vin
      yearMakeModel
      insuranceMonthly
      insuranceAccuracy
      customerTaxRate
      taxRateAccuracy
      customerState
      stateAccuracy
      createdDate
    }
    customerPickupDate @client
    customerEmail @client
    customerPhone @client
    customerLicenseUri @client
  }
`;

export const GET_CARTLEASE = gql`
  query cartLease @client {
    __typename
    pickupLocation
    dropoffLocation
    transportCost
    secondLegFee
    dropoffLegFee
    leaseTotal
    firstMonthSalesTax
    firstMonthRentalTax
    monthlySalesTax
    monthlyRentalTax
    proration
    dropoffLegSalesTax
    dropoffLegRentalTax
    paymentsTotal
    leaseFirst
    leaseMonthly
    customerPickupDate
    customerLeaseMonths
    vin
    yearMakeModel
    insuranceMonthly
    insuranceAccuracy
    customerTaxRate
    taxRateAccuracy
    customerState
    stateAccuracy
    createdDate
  }
`;

// export const LOAD_LEASEQUOTE = gql`
//   mutation loadLeaseQuote($quoteId: ID!) {
//     loadLeaseQuote(quoteId: $quoteId) @client
//   }
// `;

export const GET_LEASEACCOUNTS = gql`
  query getLeaseAccounts {
    accounts {
      skipsLeaseId
      yearMakeModel
      conditionImages
    }
    isLoggedIn @client
  }
`;

export default function ConditionImagesMenu() {
  const classes = useStyles();
  const { data, loading, error } = useQuery(GET_LEASEACCOUNTS);

  if (loading) return <Loading />;
  if (error) return <p>ERROR: {error.message}</p>;
  if (!data.isLoggedIn) return <Login />

  console.log("data");
  console.log(data);

  return (
    <Fragment>
      <PageHeading>Condition images menu</PageHeading>
      <Grid container spacing={2}>
        {data.accounts.map(account => <Grid item md={6} className={classes.menuItem}><ButtonBase component={Box} className={classes.buttonBase} onClick={event => navigate("/condition-images/" + account.skipsLeaseId)} ><Typography variant="h6">{account.yearMakeModel}</Typography><Typography>{account.skipsLeaseId}</Typography></ButtonBase></Grid>)}
      </Grid>
    </Fragment>
  )
}
